import { axiosInstance } from "../../../utils";
import _ from "lodash";

const actions = {
  CREATE_OR_UPDATE_PRODUCT_REQUESTED: "CREATE_OR_UPDATE_PRODUCT_REQUESTED",
  CREATE_OR_UPDATE_PRODUCT_SUCCEEDED: "CREATE_OR_UPDATE_PRODUCT_SUCCEEDED",
  CREATE_OR_UPDATE_PRODUCT_FAILED: "CREATE_OR_UPDATE_PRODUCT_FAILED",

  addOrUpdateProduct: (data = undefined) => {
    return {
      type: actions.CREATE_OR_UPDATE_PRODUCT_REQUESTED,
      payload: data,
    };
  },

  createOrUpdateProduct: async (data = undefined) => {
    let url = `items/create`;
    let bodyFormData = new FormData();

    if (data?.files && data?.files?.fileList?.length) {
      url = `items/import_csv`;
      // console.log("data", data?.files?.fileList[0]?.originFileObj)

      bodyFormData.append("csv", data?.files?.fileList[0]?.originFileObj);
      try {
        const product = await axiosInstance.post(url, bodyFormData);
        return { ...product?.data, file_upload: true };
      } catch (error) {
        throw error;
      }
    } else {
      if (data.name) bodyFormData.set("name", data.name);
      if (data.name_ar) bodyFormData.set("name_ar", data.name_ar);
      if (data.barcodes)
        bodyFormData.set("barcodes", JSON.stringify(data.barcodes));
      if (data.brand_path)
        bodyFormData.set("brand_path", JSON.stringify(data.brand_path));
      if (data.category_path)
        bodyFormData.set("category_path", JSON.stringify(data.category_path));
      if (data.tags) bodyFormData.set("tags", JSON.stringify(data.tags));
      if (data.commission != null) bodyFormData.set("commission", data.commission);
      if (data.cost != null) bodyFormData.set("cost", data.cost);
      if (data.price != null) bodyFormData.set("price", data.price);
      if (data.tax != null) bodyFormData.set("tax", data.tax);
      if (data.description) bodyFormData.set("description", data.description);
      if (data.description_ar)
        bodyFormData.set("description_ar", data.description_ar);
      if (data.classification) {
        bodyFormData.set("listing_classification_id", data.classification?._id);
      }
      if (data.pack_size) bodyFormData.set("pack_size", data.pack_size);
      if (data.color) bodyFormData.set("pack_size", data.color);
      bodyFormData.set("is_active", !!data.is_active);
      bodyFormData.set("is_default", !!data.is_default);
      bodyFormData.set("is_pillvery_select", !!data.is_pillvery_select);
      bodyFormData.set(
        "is_trending",
        data.is_near_expiry ? false : !!data.is_trending
      );
      bodyFormData.set("offer_percentage", data.offer_percentage);
      bodyFormData.set("quantity", _.max([data?.quantity, 0]));
      bodyFormData.set("gift", !!data.gift);
      if (data.supplier_ids) {
        bodyFormData.set("supplier_ids", JSON.stringify(data.supplier_ids));
      }
      if (data.expiry_date) {
        bodyFormData.set("expiry_date", data.expiry_date);
      }
      if (data.original_item_id) {
        bodyFormData.set("original_item_id", data.original_item_id);
      }
      if (data.is_near_expiry) {
        bodyFormData.set("is_near_expiry", data.is_near_expiry);
      }

      if (data.images) {
        let images = [];

        for (let i = 0; i < data?.images.length; i++) {
          if (data.images[i].originFileObj) {
            bodyFormData.append("images", data.images[i].originFileObj);
          } else {
            images.push(data.images[i].url);
          }
        }
        console.log(images, "imagesimages");
        bodyFormData.append("images_urls", JSON.stringify(images));
      }
      if (data.barcode_picture)
        bodyFormData.append("barcode_picture", data.barcode_picture);
      if (data.group_id) bodyFormData.set("group_id", data.group_id);
      if (data.fields?.length)
        bodyFormData.set("fields", JSON.stringify(data.fields));
      if (data._id) {
        url = `items/` + data._id;
        try {
          const product = await axiosInstance.put(url, bodyFormData);
          return product.data;
        } catch (error) {
          throw error;
        }
      } else {
        if (data.group_id) bodyFormData.set("group_id", data.group_id);
        if (data.fields)
          bodyFormData.set("fields", JSON.stringify(data.fields));
        try {
          const product = await axiosInstance.post(url, bodyFormData);
          return product.data;
        } catch (error) {
          throw error;
        }
      }
    }
  },
};

export default actions;
